import { Typography } from 'libs/ui';

import {
  convertDateByTimezone,
  formatToDate,
  formatToDateTimeShort,
  formatWithGmtOffset,
} from '../date';

export const renderDate = <Row extends object>(
  item: Row,
  field: keyof Row,
  timezoneOffset?: number
) => {
  const date = item[field];

  if (!(date instanceof Date)) {
    return null;
  }

  let value = '';
  if (timezoneOffset !== undefined) {
    const timezoneDate = convertDateByTimezone(date, timezoneOffset);
    value = formatToDate(timezoneDate);
  } else {
    value = formatToDate(date);
  }

  return <Typography title={value}>{value}</Typography>;
};

export const renderDateTime = <Row extends object>(
  item: Row,
  field: keyof Row,
  timezoneOffset?: number
) => {
  const date = item[field];

  if (!(date instanceof Date)) {
    return null;
  }

  let value = '';
  if (timezoneOffset !== undefined) {
    const timezoneDate = convertDateByTimezone(date, timezoneOffset);
    value = formatWithGmtOffset(
      timezoneDate,
      timezoneOffset,
      formatToDateTimeShort
    );
  } else {
    value = formatToDateTimeShort(date);
  }

  return <Typography title={value}>{value}</Typography>;
};
